<template>
  <v-dialog :value="value" max-width="640px" persistent @keydown.esc="close">
    <v-card>
      <v-card-title>Utloggning</v-card-title>

      <v-card-text>
        Du har varit inaktiv för länge och loggas därför ut om
        {{ counter }} sekunder.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="stay">
          <v-icon small>mdi-lightbulb-on</v-icon>
          Fortsätt vara inloggad
        </v-btn>
        <v-btn @click="logout">
          <v-icon>$logout</v-icon>
          Logga ut
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmLogoutDialog",
  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      timer: null,
      counter: 60,
    };
  },
  computed: {},
  methods: {
    tick() {
      if (1 > --this.counter) {
        this.logout();
      }
    },
    stay() {
      this.$store.dispatch("ping");
      this.close();
    },
    logout() {
      this.$emit("logout");
    },
    close() {
      this.$emit("input", false);
    },
  },
  watch: {
    value(state) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      if (state) {
        this.counter = 60;
        this.timer = setInterval(this.tick, 1000);
      } else {
        this.timer = null;
      }
    },
  },
};
</script>
